var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LandingpageCard',{attrs:{"name":_vm.name},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('Upselling',{attrs:{"type":_vm.type,"slug":_vm.slug,"requirements":_vm.requirements,"running":_vm.running,"submit":_vm.submit,"is-booking-blocked":_vm.isBookingBlocked,"price":_vm.price,"variant":_vm.variant}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }